import { ORPCError } from "@orpc/client";

/**
 * Whether a failed consent lookup is worth retrying. A 4xx means this session
 * is not a patient of the workspace, so the answer will not change. Anything
 * else, a network drop or a 5xx, can.
 */
export function canRetryConsentLookup(error: unknown): boolean {
  if (!(error instanceof ORPCError)) return true;
  return error.status < 400 || error.status >= 500;
}
